import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FolderOpen, Plus, X, ArrowRight, Building2 } from 'lucide-react';

/**
 * NoWorkspaceModal - Modal displayed when user tries to launch a scan without any workspace
 * Explains the importance of workspaces and redirects to workspace creation
 */
const NoWorkspaceModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleCreateWorkspace = () => {
    onClose();
    navigate('/workspaces');
  };

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-brand-black-light border-2 border-brand-green/30 rounded-2xl max-w-lg w-full animate-in fade-in zoom-in duration-300">
        {/* Header */}
        <div className="p-6 border-b border-brand-green/20">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-3 bg-brand-green/20 rounded-xl">
                <FolderOpen className="w-8 h-8 text-brand-green" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-white">Workspace Requis</h2>
                <p className="text-gray-400 text-sm">Create a workspace before launching a scan</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-brand-black rounded-lg transition-colors"
            >
              <X className="w-5 h-5 text-gray-400 hover:text-white" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <div className="bg-brand-black rounded-xl p-4 border border-gray-800">
            <h3 className="font-semibold text-white mb-2 flex items-center gap-2">
              <Building2 className="w-5 h-5 text-brand-green" />
              Pourquoi un workspace ?
            </h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="flex items-start gap-2">
                <span className="text-brand-green mt-1">•</span>
                <span>Organisez vos scans par client ou projet</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-green mt-1">•</span>
                <span>Generate professional reports per workspace</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-green mt-1">•</span>
                <span>Manage dedicated internal VPNs for each client</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-green mt-1">•</span>
                <span>Suivez l'historique des audits par entreprise</span>
              </li>
            </ul>
          </div>

          <p className="text-gray-500 text-sm text-center">
            A workspace represents a client or an audit project.
            Create one to start your security scans.
          </p>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-800 flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 px-4 bg-gray-800 hover:bg-gray-700 text-gray-300 rounded-xl font-medium transition-colors"
          >
            Annuler
          </button>
          <button
            onClick={handleCreateWorkspace}
            className="flex-1 py-3 px-4 bg-gradient-to-r from-brand-green to-green-600 hover:from-green-600 hover:to-brand-green text-black rounded-xl font-bold transition-all flex items-center justify-center gap-2"
          >
            <Plus className="w-5 h-5" />
            Create a workspace
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoWorkspaceModal;
